/** Tiny pub/sub for the staff-only page data timing overlay. */
export const PERF_OVERLAY_EVENT = "perf-overlay:report";

export function reportPageDataTime(ms: number, label?: string) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PERF_OVERLAY_EVENT, { detail: { ms: Math.round(ms), label } }));
}
